import PropTypes from "prop-types";
import React from "react";
// @mui
import { Box, LinearProgress, Stack, Typography } from "@mui/material";
// assets
import { TASK_SOURCE, TASK_TYPE } from "src/assets/data/text";
// components
import Image from "src/components/image";
import Button from "src/components/template/button";
// utils
import { fDateTask } from "src/utils/format-time";

// ----------------------------------------------------------------------

TaskItem.propTypes = {
    detail: PropTypes.object,
    onDialog: PropTypes.func
};

export default function TaskItem({ detail, onDialog }) {
    const {
        biz_type: bizType,
        task_type: taskType,
        source,
        fail_reason: failReason,
        import_errs: importErrors,
        progress,
        status,
        created_at: createdAt
    } = detail;

    const type = bizType || taskType;

    const iconURL = TASK_TYPE?.[ type ]?.icon ?? "";

    const showError = failReason || ( importErrors && importErrors.length > 0 );
    const showFailReason = failReason;
    const showImportErrors = importErrors && importErrors.length > 0;

    // ----------------------------------

    return (
        <Stack direction="row" height="fit-content" minHeight="92px" py="20px" spacing="10px">
            <Stack width="40px" height="40px" alignItems="center" justifyContent="center" sx={ { backgroundColor: "#1C1C1E", borderRadius: "8px", overflow: "hidden" } }>
                { iconURL && <Image src={ iconURL } alt="biz type" width={ 30 } height={ 30 } objectFit="contain" disabledEffect /> }
            </Stack>

            <Box sx={ { position: "relative", display: "flex", flex: 1, alignItems: "center", flexDirection: "column", gap: "5px" } }>
                { status === "PROCESSING" && (
                    <>
                        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
                            <Typography variant="body1" color="text.secondary">{ `${ TASK_TYPE?.[ type ]?.display || "-" }` }</Typography>

                            <Typography variant="body1" color="text.secondary">{ `${ Math.round(progress) }%` }</Typography>
                        </Stack>

                        <Box sx={ { width: "100%" } }>
                            <LinearProgress variant="buffer" color="info" value={ progress } sx={ { height: "6px" } } />
                        </Box>
                    </>
                ) }

                { status === "SUCCESS" && (
                    <>
                        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
                            <Typography variant="body1" color="text.secondary">{ `${ TASK_TYPE?.[ type ]?.display || "-" }` }</Typography>

                            <Typography variant="body1" color="text.secondary">Completed</Typography>
                        </Stack>

                        <Box sx={ { width: "100%" } }>
                            <LinearProgress variant="determinate" color="info" value={ 100 } sx={ { height: "6px" } } />
                        </Box>
                    </>
                ) }

                { status === "FAILED" && (
                    <>
                        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
                            <Typography variant="body1" color="text.secondary">{ `${ TASK_TYPE?.[ type ]?.display || "-" }` }</Typography>

                            <Typography variant="body1" color="error">Failed</Typography>
                        </Stack>

                        <Box sx={ { width: "100%" } }>
                            <LinearProgress variant="determinate" color="error" value={ 100 } sx={ { height: "6px" } } />
                        </Box>

                        { showError && (
                            <Stack direction="row" alignItems="center" spacing="4px" width="fit-content" maxWidth="200px" mr="auto">
                                { showFailReason && (
                                    <Typography variant="caption" color="error" noWrap>
                                        { failReason }
                                    </Typography>
                                ) }

                                { showImportErrors && (
                                    <Stack direction="row">
                                        &nbsp;

                                        <Button variant="text" typographyProps={ { variant: "caption", color: "error", sx: { textDecoration: "underline" }, noWrap: true } } onClick={ () => onDialog(importErrors) }>
                                            Read more
                                        </Button>

                                        <Typography variant="caption" color="error">...</Typography>
                                    </Stack>
                                ) }
                            </Stack>
                        ) }
                    </>
                ) }

                <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
                    <Stack width="fit-content" maxWidth="130px">
                        <Typography variant="caption" color="text.tertiary" noWrap>{ `${ TASK_SOURCE?.[ source ] || source || "-" }` }</Typography>
                    </Stack>

                    <Typography variant="caption" color="text.tertiary" noWrap>{ `${ createdAt ? fDateTask(createdAt) : "-" }` }</Typography>
                </Stack>
            </Box>
        </Stack>
    );
}
